export function seasonIndex(scrollLeft, columnWidth, count) {
  if (columnWidth <= 0 || count <= 0) return 0
  return Math.max(0, Math.min(count - 1, Math.round(scrollLeft / columnWidth)))
}

export default {
  mounted() {
    this.mobile = window.matchMedia("(max-width: 639px)")
    this.pending = false
    this.desired = null
    this.destroyedFlag = false
    this.serverSeason = this.el.dataset.selectedSeason
    this.onScroll = () => {
      if (!this.mobile.matches) return
      clearTimeout(this.scrollTimer)
      this.scrollTimer = setTimeout(() => this.settle(), 180)
    }
    this.onScrollEnd = () => {
      clearTimeout(this.scrollTimer)
      this.settle()
    }
    this.onResize = () => this.align()
    this.el.addEventListener("scroll", this.onScroll, {passive: true})
    this.el.addEventListener("scrollend", this.onScrollEnd)
    this.mobile.addEventListener("change", this.onResize)
    this.observer = new ResizeObserver(this.onResize)
    this.observer.observe(this.el)
    this.align()
  },

  headers() {
    return Array.from(this.el.querySelectorAll("#payroll-table > thead [data-payroll-season]"))
  },

  align() {
    if (!this.mobile.matches || this.pending) return
    const width = this.el.clientWidth
    if (!width) return
    this.el.style.setProperty("--payroll-player-width", `${width * 0.58}px`)
    this.el.style.setProperty("--payroll-season-width", `${width * 0.42}px`)
    this.el.style.setProperty("--payroll-viewport", `${width}px`)
    const index = this.headers().findIndex(el => el.dataset.payrollSeason === this.el.dataset.selectedSeason)
    if (index >= 0) this.el.scrollTo({left: index * width * 0.42, behavior: "instant"})
    this.revealChip()
  },

  revealChip() {
    const chips = document.getElementById("payroll-season-tabs")
    const chip = chips?.querySelector("[aria-pressed='true']")
    if (!chip) return
    // Scroll only the chip strip; scrollIntoView would also jump the page.
    const delta = chip.getBoundingClientRect().left - chips.getBoundingClientRect().left
    if (delta < 0 || delta + chip.offsetWidth > chips.clientWidth) {
      chips.scrollLeft += delta - (chips.clientWidth - chip.offsetWidth) / 2
    }
  },

  settle() {
    if (!this.mobile.matches || this.destroyedFlag || !this.el.clientWidth) return
    const headers = this.headers()
    const index = seasonIndex(this.el.scrollLeft, this.el.clientWidth * 0.42, headers.length)
    this.desired = headers[index]?.dataset.payrollSeason
    this.selectDesired()
  },

  selectDesired() {
    if (this.pending || !this.desired || this.desired === this.el.dataset.selectedSeason) return
    const season = this.desired
    this.pending = true
    this.pushEvent("select_cap_year", {season}, () => {
      if (this.destroyedFlag) return
      this.pending = false
      this.revealChip()
      // Serialize requests so a slow response cannot undo a newer swipe.
      if (this.desired !== season) this.selectDesired()
    })
  },

  updated() {
    const season = this.el.dataset.selectedSeason
    const changed = season !== this.serverSeason
    this.serverSeason = season
    // LiveView owns all salary cells; the hook only moves the viewport.
    // Preserve the user's scroll while their selection is being acknowledged.
    if (changed && !this.pending) this.align()
    this.revealChip()
  },

  destroyed() {
    this.destroyedFlag = true
    clearTimeout(this.scrollTimer)
    this.observer.disconnect()
    this.mobile.removeEventListener("change", this.onResize)
    this.el.removeEventListener("scroll", this.onScroll)
    this.el.removeEventListener("scrollend", this.onScrollEnd)
  },
}
